import styled from "styled-components/macro";

export const FilterContainer = styled.div`
    display: flex;
    flex-flow: row wrap;
    background-color: rgba(242, 242, 242, 1);
    margin: 10px 0px 0px 0px;
    padding: 10px 0px 10px 10px;
    border-radius: ${props => (props.theme === true ? "5px 5px 0px 0px" : "5px")};
`;
